import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { marketplaceAPI } from '../services/api';
import '../styles/Payment.css';

const PaymentSuccess = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const confirmPayment = async () => {
      try {
        const paymentIntentId = searchParams.get('payment_intent');

        if (!paymentIntentId) {
          setError(t('paymentSuccess.missingParams'));
          setLoading(false);
          return;
        }

        await marketplaceAPI.confirmPurchase(paymentIntentId);
        setSuccess(true);

        // Vider le panier si c'était un achat panier
        const type = searchParams.get('type');
        if (type === 'cart') {
          localStorage.removeItem('cart');
        }
      } catch (err) {
        setError(err.response?.data?.message || 'Erreur lors de la confirmation du paiement');
      } finally {
        setLoading(false);
      }
    };

    confirmPayment();
  }, [searchParams]);

  if (loading) {
    return (
      <div className="payment-container">
        <div className="payment-card">
          <h2>{t('paymentSuccess.verifying')}</h2>
          <p>{t('paymentSuccess.pleaseWait')}</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="payment-container">
        <div className="payment-card">
          <h2>{t('paymentSuccess.error')}</h2>
          <div className="error-message">{error}</div>
          <button className="btn-primary" onClick={() => navigate('/')} style={{ marginTop: 20 }}>
            {t('common.backToHome')}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="payment-container">
      <div className="payment-card success-card">
        <div className="success-icon">&#10003;</div>
        <h2>{t('paymentSuccess.confirmed')}</h2>
        <p>
          {t('paymentSuccess.paymentAccepted')}
        </p>

        <div className="next-steps">
          <h3>{t('buy.nextSteps')}</h3>
          <ol>
            <li>{t('buy.step1')}</li>
            <li>{t('buy.step2')}</li>
            <li>{t('buy.step3')}</li>
          </ol>
        </div>

        <div className="button-group">
          <button className="btn-primary" onClick={() => navigate('/my-purchases')}>
            {t('buy.viewPurchases')}
          </button>
          <button className="btn-secondary" onClick={() => navigate('/')}>
            {t('buy.continueShopping')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
